import React from 'react';
import { Image, Grid, Button } from 'semantic-ui-react';

const HomeIntro = () => (
    <Grid>
        <Grid.Row columns={2}>
            <Grid.Column width={11}>
                <h1 className="intro-header">Hi! I'm Yahia Bakour, software engineer and coffee enthusiast.</h1>
                <p className="intro-content">I'll be adding updates about my life, blog posts on things i care about, cool designs that I come across on the web, and whatever else pops into my head.</p>
                <div style={{ flex: 'row' }}>
                    <ContactMeButton />
                </div>
            </Grid.Column>
            <Grid.Column width={5}>
                <Image src="images/yahia.jpeg" size="medium" floated="right" rounded />
            </Grid.Column>
        </Grid.Row>
    </Grid>
);

const ContactMeButton = () => (
    <Button href="mailto:bakour@hey.com" size="large" secondary>
        Contact Me
    </Button>
);

export default HomeIntro;
